import React from 'react';
import LinkListCard from 'components/partials/parts/link-list-card';
import { LinkListCardProps } from 'types/link-list-card-props';

export type LinkListCardsProps = {
    headline?: string;
    cards: LinkListCardProps[];
};

const LinkListCards: React.FC<LinkListCardsProps> = ({ headline, cards }) => (
    <div className="pattern">
        <div className="container container--md">
            {headline && <h2 className="h3 pattern__headline">{headline}</h2>}
            <div className="grid-container grid-container--2up-narrow">
                {cards.map((card, index) => (
                    <LinkListCard {...card} key={index} />
                ))}
            </div>
        </div>
    </div>
);

export default LinkListCards;